<template>
  <div
    ref="layer"
    v-show="layerH"
    class="calendar-day-view-layer"
    :style="{
      top: `${layerY ? layerY + 3 : 0 }px`,
      height: `${innerTheme==='theme-create' ? 22 : layerH - 6}px`
    }"
    :class="[innerTheme]"
    @click="clickEvent"
  >
    <span
      v-if="innerTheme === 'theme-create'"
      class="ibass ibass-add"
    />
    <span
      class="calendar-day-view-layer-label"
      v-html="label"
    />
  </div>
</template>
<script>
import mixin from '@/mixins/calendar'
export default {
  name: 'CalendarHoursLayer',
  mixins: [ mixin ],
  props: {
    iLayerY: {
      type: Number,
      default: 0
    },
    iLayerH: {
      type: Number,
      default: 0
    },
    iLabel: {
      type: String
    },
    theme: {
      type: String
    }
  },
  data () {
    return {
      layerH: 0,
      layerY: 0,
      label: '',
      startDragging: false,
      innerTheme: ''
    }
  },
  watch: {
    iLayerH (newValue, oldValue) {
      this.label = this.iLabel
      this.layerY = this.iLayerY
      this.layerH = Math.max(newValue, 0)
    },
    iLayerY (newer, older) {
      this.label = this.iLabel
      this.layerY = newer
      this.layerH = this.iLayerH
    },
    theme (after, before) {
      this.innerTheme = after || 'theme-create'
    },
    '$store.state.calendar.dragDropStatus': {
      handler (after, before) {
        this.layerH = 0
      },
      deep: true
    }
  },
  mounted () {
    this.bindEvent()
    this.scrollParent = this._getScrollParent(this.$refs.layer)
  },
  methods: {
    dragStart (ev) {
      this.startDragging = true
      this.$emit('changeTheme', 'theme-icourt')
      let __layerY = this.transformDate(ev.layerY)
      this.layerH = 0
      this.layerY = __layerY
      this.originY = __layerY
      ev.dataTransfer.setDragImage(document.querySelector('#dragImage'), 0, 0)
    },
    dragHandler (ev) {
      if (ev.screenX === 0 && ev.screenY === 0) return
      let __layerY = this.transformDate(ev.layerY)
      this.layerH = Math.abs(__layerY - this.originY)
      this.layerY = __layerY < this.originY ? __layerY : this.originY
      this._updateScrollView(this.layerY, this.layerH)
      this.setAreaLabel()
      ev.preventDefault()
    },
    dragEnd (ev) {
      const params = {
        startTime: this.layerY,
        height: this.layerH
      }
      if (this.layerH === 0 || !this.startDragging) return
      // this.$analysis.track('TaskActionsSupplement', {
      //   action_type: 'create_task_by_drag'
      // })
      this.startDragging = false
      this.$emit('dragEnd', params)
    },
    // 显示选中区域的时间范围
    setAreaLabel () {
      let originDate = moment().startOf('day')
      const label = `${originDate.add(this.layerY, 'minute').format('HH:mm')}-${originDate.add(this.layerH, 'minute').format('HH:mm')}`
      this.label = this.layerH === 30 ? label : label + ` <br/> 新建任务`
    },
    // 拖拽区域的增减最小单位为30分钟
    transformDate (y) {
      y = Math.min(y, 24 * 60)
      y = Math.max(0, y)
      return Math.floor(y / 30) * 30
    },
    clickEvent (event) {
      event.stopPropagation()
      this.$emit('click', event)
    },
    bindEvent () {
      // 此处未兼容日视图边缘也能拖动新建任务
      this.parentNode = this.$refs.layer.parentNode.parentNode.parentNode
      this.parentNode.setAttribute('draggable', true)
      this.parentNode.addEventListener('dragstart', this.dragStart)
      this.parentNode.addEventListener('drag', this.dragHandler)
      this.parentNode.addEventListener('dragend', this.dragEnd)
    },
    unbindEvent () {
      this.parentNode.setAttribute('draggable', false)
      this.parentNode.removeEventListener('dragstart', this.dragStart)
      this.parentNode.removeEventListener('drag', this.dragHandler)
      this.parentNode.removeEventListener('dragend', this.dragEnd)
    }
  },
  beforeDestroy () {
    this.unbindEvent()
  }
}
</script>
<style lang="stylus">
.calendar-day-view-layer
  display flex
  justify-content center
  align-items center
  position absolute
  left 2px
  right 2px
  // width 100%
  z-index 20
  border-radius 3px
  cursor pointer
  .ibass
    margin-right 2px
  &.theme-create
    left 3px
    right 3px
    padding-left 3px
    background-color #fff
    border 2px solid rgba(6, 6, 6, .2)
    .calendar-day-view-layer-label
      color #4A4A4A
    .ibass
      line-height 10px
      color #666666
  &.theme-icourt
    display flex
    background-color #FA8919
    opacity .8
    .calendar-day-view-layer-label
      padding-left 4px
  &-label
    width 100%
    color #fff
    font-size .75rem
</style>
